import React, { useEffect, useState } from 'react';
import History from './History';
import InvoiceTogel from './InvoiceTogel';
import MemberList from './MemberList';
import BonusReferral from './BonusReferral';
import BonusEvent from './BonusEvent';
import InfoTurnover from './InfoTurnover';
import Pagination from '../../../LobbyContent/SubComponents/Pagination';
import { dataEntryPerPage, setPaginationData } from '../../../../redux/actions';
import { useDispatch } from 'react-redux';
import { withTranslation } from 'react-i18next';
import PaginationResult from '../../../LobbyContent/SubComponents/PaginationResult';


const InformationTab = (props) => {

  const dispatch = useDispatch()

  const [resetPage, setResetPage] = useState(false);

  const [perPage, setPerPage] = useState(10);
  const [selectedTab, setSelectedTab] = useState("History");
  // Function to handle tab change
  const renderComponent = () => {
    switch (selectedTab) {
      case "History":
        return <History handlePageNo={handlePageNo} />;
      case "InvoiceTogel":
        return <InvoiceTogel handlePageNo={handlePageNo} />;
      case "MemberList":
        return <MemberList />;
      case "BonusReferral":
        return <BonusReferral />;
      case "InfoTurnover":
        return <InfoTurnover perPageLength={perPage}/>;
      case "BonusEvent":
        return <BonusEvent />;
      default:
        return null;
    }
  };

  const handleTabClick = (tabName, e) => {
    // Prevent event propagation to parent elements
    e.stopPropagation();
    setSelectedTab(tabName);
    dispatch(setPaginationData(tabName))

  };

  const handlePageNo = () => {
    setResetPage(true);
    window.scrollTo(0, 0)
  };

  const handleResetPageNo = () => {
    setResetPage(false);
  };


  const handlePerRowsChange = (e) => {
    const perPageValue = e.target.value;
    setPerPage(perPageValue);
    setResetPage(true);
  };


  useEffect(() => {
    setPerPage(10);
  }, [selectedTab]);

  dispatch(dataEntryPerPage(perPage))


  return (
    <div className='main_contain'>
      <div className="tabs_select_row">
        <div className="tabs">
          <button
            className={selectedTab === "History" ? "tab active" : "tab"}
            onClick={(e) => handleTabClick("History", e)}
          >
            {props.t('transaction')}
          </button>
          <button
            className={selectedTab === "InvoiceTogel" ? "tab active" : "tab"}
            onClick={(e) => handleTabClick("InvoiceTogel", e)}
          >
            {"Invoice Togel"}
          </button>
          <button
            className={
              selectedTab === "MemberList" ? "tab active" : "tab"
            }
            onClick={(e) => handleTabClick("MemberList", e)}
          >
            {props.t('member_list')}
          </button>
          <button
            className={
              selectedTab === "BonusReferral" ? "tab active" : "tab"
            }
            onClick={(e) => handleTabClick("BonusReferral", e)}
          >
            {props.t('bonus_referral')}
          </button>
          <button
            className={
              selectedTab === "InfoTurnover" ? "tab active" : "tab"
            }
            onClick={(e) => handleTabClick("InfoTurnover", e)}
          >
            {props.t('info_turnover')}
          </button>
          <button
            className={selectedTab === "BonusEvent" ? "tab active" : "tab"}
            onClick={(e) => handleTabClick("BonusEvent", e)}
          >
            {props.t('bonus_event')}
          </button>
        </div>
        <select
          className="dropdown"
          onChange={handlePerRowsChange}
          value={perPage}
        >
          <option value={10}>{10}</option>
          <option value={25}>{25}</option>
          <option value={50}>{50}</option>
          <option value={100}>{100}</option>
        </select>
      </div>
      <div>{renderComponent()}</div>
      {selectedTab !== "InvoiceTogel" && (
        <Pagination resetPage={resetPage} handleResetPageNo={handleResetPageNo} />
      )}
    </div>
  );
};

export default withTranslation()(InformationTab);
